import React from 'react';
import quoteIcon from 'images/icons/quote-left-solid.svg'

type TestimonialCardInfoSlickProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  logo: string,
  name: string,
  title: string,
  dcp: string,

}
const TestimonialCardInfoSlick: React.FC<TestimonialCardInfoSlickProps> = ({ logo, name, title, dcp, ...props }) => {
  return (
    <div className='px-1 mx-1'>
    <div {...props} className=''>
      <img className='h-5 mb-3' src={logo} alt='companyLogo' style={{width:'5rem', height:"100%"}}></img>
      <div className='client-info max-w-sm rounded overflow-hidden shadow-lg'>
        <div className='px-5'>
          <div className='pt-5'>
            <img className='float-left ml-2 my-2 h-12 mx-1' src={quoteIcon} alt='quoteIcon' style={{width: 'auto'}}></img>
            <div className='client-name '>
              <div className='font-bold text-xl'>{name}</div>
              <span className='text-gray-700'>{title}</span>
            </div>
          </div>
          <div className='float-none mt-3 pb-5 px-2 font-light'>
            {dcp}
          </div>
        </div>

      </div>
  </div>
  </div>
  )
}

// const TestimonialCardInfo: React.FC<TestimonialCardInfoSlickProps> = ({card, ...props}) => {

//     return (
//       <div {...props} className={`${props.className ? props.className : ''}`} style={{textAlign: "left"}}>
//         {
//           card.map((item, index) => {
//             return (
//               <div className='px-1'>
//                 <div {...props} className=''>
//                   <img className='h-5 mb-3' src={item.logo} alt='companyLogo' style={{width:'70px', height:"100%"}}></img>
//                   <div className='client-info max-w-sm rounded overflow-hidden shadow-lg'>
//                     <div className='px-5'>
//                       <div className='pt-5'>
//                         <img className='float-left ml-2 my-2 h-12 mx-1' src={quoteIcon} alt='quoteIcon' style={{width: 'auto'}}></img>
//                         <div className='client-name '>
//                           <div className='font-bold text-xl'>{item.name}</div>
//                           <span className='text-gray-700'>{item.title}</span>
//                         </div>
//                       </div>
//                       <div className='float-none mt-3 pb-5 px-2 font-light'>
//                         {item.dcp}
//                       </div>
//                     </div>

//                   </div>
//               </div>
//               </div>
              
//             )
//           })
//         }
        
//       </div>
//     )

// }

export default TestimonialCardInfoSlick